module.exports = __webpack_public_path__ + "static/media/service_live-music.7e7bb072.jpg";